import {DAG_ConnectionAttemptSource, type DAG_ConnectionAttempt} from "~/domainModels/dag/dataSourceConnectionAttempt";
import {uniqueUuid} from "@vesta/unique/unique";
import {redirect} from "@tanstack/react-router";
import {
    throwRedirectToConfigConnectDataSourcesWhenPresent,
    throwRedirectToConfigDataSourceDetailWhenPresent,
} from "~/workspaceConfig/configOttosyncRedirects";

export enum ThirdPartyPlatformIds {
    // ads
    amazon = "457f3f98-a586-4659-8c65-26f76cd74fef",
    // seller, vendor
    amazonMarketplace = "f5c1075b-e5b3-4ce8-9b25-d42fb23659a7",
    facebook = "a547a326-362f-4c39-962c-033274d1180d",
    flipkart = "4928d306-bc11-4c48-8ad4-7b6a32f0e737",
    google = "b9178838-39d1-4986-b3a5-a42d428cecaa",
    linkedIn = "9265d2ea-fa77-4827-9918-f377c01dd17c",
}

export function redirectToConnectionPage({connectionAttempt}: {connectionAttempt: DAG_ConnectionAttempt}) {
    switch (connectionAttempt.source) {
        case DAG_ConnectionAttemptSource.dataSourcePage: {
            throwRedirectToConfigDataSourceDetailWhenPresent({
                workspaceId: connectionAttempt.workspaceId,
                dataSourceId: connectionAttempt.dataSourceId,
                connectionAttemptId: connectionAttempt.id,
            });
            throw redirect({
                to: `/w/$workspaceId/ottosync/data-sources/$dataSourceId`,
                params: {
                    workspaceId: connectionAttempt.workspaceId,
                    dataSourceId: connectionAttempt.dataSourceId,
                },
                search: {
                    connectionAttemptId: connectionAttempt.id,
                },
            });
        }
        case DAG_ConnectionAttemptSource.onboardingPage: {
            throwRedirectToConfigConnectDataSourcesWhenPresent({
                workspaceId: connectionAttempt.workspaceId,
                onboardingJourneyId: connectionAttempt.onboardingJourneyId,
                connectionAttemptId: connectionAttempt.id,
            });
            throw redirect({
                to: "/w/$workspaceId/ottosync/onboarding/connect-data-sources",
                params: {
                    workspaceId: connectionAttempt.workspaceId,
                },
                search: {
                    onboardingJourneyId: connectionAttempt.onboardingJourneyId,
                    connectionAttemptId: connectionAttempt.id,
                },
            });
        }
        default: {
            throw new Error(uniqueUuid`5e2cc683-cd26-4c27-8229-81fffd61850f`);
        }
    }
}
